var $9df6ccd8ba00758d$exports = {};
$9df6ccd8ba00758d$exports = {
    "collapse": `Sa\u{17E}mi`,
    "expand": `Pro\u{161}iri`
};


export {$9df6ccd8ba00758d$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
